var _Skeleton, _Skeleton2;
import { cx } from 'class-variance-authority';
import { Skeleton } from '@crehana/compass.ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var BreadcrumbSkeleton = function BreadcrumbSkeleton(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('tw-flex tw-items-center tw-gap-0.8', className),
    children: [_Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-5.6 sm:tw-w-4 tw-h-1.6 tw-rounded-1",
      animated: true
    })), _Skeleton2 || (_Skeleton2 = /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-10.4 tw-h-1.6 tw-rounded-1 tw-hidden sm:tw-block",
      animated: true
    }))]
  });
};